module.exports = __webpack_public_path__ + "7281a7b1cb1934c2566910d9dd1aa2ef.png";